import { reportError } from './error-reporting'

/**
 * Force the client onto the latest deployed version, defeating stale PWA / HTTP caches.
 *
 * The app is a PWA (`registerType: 'autoUpdate'`); a returning user can be running a cached
 * app shell whose lazy chunks no longer exist on the server (→ blank page). This unregisters
 * the service worker, clears all Cache Storage, then hard-reloads so the browser fetches a
 * fresh index.html + assets. Safe to call from a user-facing "Refresh" / "Update" button.
 */
export async function forceRefreshApp(): Promise<void> {
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations()
      await Promise.all(regs.map(r => r.unregister()))
    }
    if ('caches' in window) {
      const keys = await caches.keys()
      await Promise.all(keys.map(k => caches.delete(k)))
    }
  } catch (err) {
    // Best-effort cache clear — reload regardless so the user still gets a fresh fetch.
    reportError(err, { where: 'forceRefreshApp' })
  } finally {
    window.location.reload()
  }
}
